import { connect } from 'react-redux';
import Navigator from '../components/Navigator';
import { changePage } from '../store/actions/app';

const mapStateToProps = state => {

    return { route: state.app.route };

};

const mapDispatchToProps = dispatch => {

    return { onChangePage: () => dispatch( changePage() ) };

};

export default connect( mapStateToProps, mapDispatchToProps )( Navigator );